import typography from '../typography';

export default {
  root: {
    fontSize: typography.subtitle1.fontSize,
  },
};
